import N2StylesModal from "./N2StylesModal";

const idjModalPresent = () => $(".js-idj-errors").length;

const InDesignErrorsModalOpener = () => {
  if (idjModalPresent()) {
    N2.handle("click", ".js-idj-errors", (evt) => {
      evt.preventDefault();

      new N2StylesModal(".js-show-in-design-errors");
    });
  }
};

export default InDesignErrorsModalOpener;
